import { DataTable } from 'primereact/datatable';
import Heading from '../../../../components/Heading/Heading';
import styles from '../../css/User.module.css';
import { useState, useEffect } from 'react';
import {
	approveUserRoleAction,
	generateUserRoleDetails,
	generateUserRoles,
	removeUserRole,
} from '../../../../utils/common.utils';
import CONSTANTS from '../../../../constants';
import { Column } from 'primereact/column';
import {
	getMonthFormatDate,
	getTimestamp,
} from '../../../../utils/getDate.utils';
import Icon from '../../../../components/Icon/Icon';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import ViewUserData from '../../Users/List Users/ViewUserData';

const ApproveUserRoles = () => {
	const [userRoles, setUserRoles] = useState([]);
	const [userRoleDetails, setUserRoleDetails] = useState({});

	useEffect(() => {
		generateUserRoles(setUserRoles);
	}, []);

	const handleApproveUserRole = (rowData) => {
		approveUserRoleAction(rowData.roleName, setUserRoles);
	};

	const handleDeleteUserRole = (rowData) => {
		removeUserRole(rowData.roleName, setUserRoles);
	};

	const handleGetUserRoleDetails = (rowData) => {
		generateUserRoleDetails(
			rowData.roleName,
			setUserRoleDetails,
			userRoles,
			setUserRoles
		);
	};

	const handleShowPermission = (rowData) => {
		//Get user role obj and change visibility
		const newUserRoleList = userRoles.map((obj) => {
			if (obj.roleName === rowData.roleName) {
				const newUserRoleObj = { ...obj, visiblePermission: true };
				return newUserRoleObj;
			}
			return obj;
		});
		// console.log(newUserRoleList);
		//Set new user role list to re-render the rowData
		setUserRoles(newUserRoleList);
	};

	const creationDateTemplate = (field) => {
		const convertedTimestamp = getTimestamp(field.creationDate);
		const date = getMonthFormatDate(convertedTimestamp?.split(' ')[0]);
		const time = convertedTimestamp?.split(' ')[1];
		const ampm = convertedTimestamp?.split(' ')[2];
		return <span>{`${date} ${time} ${ampm}`}</span>;
	};

	const actionBodyTemplate = (rowData) => {
		return (
			<div className={styles['actions__container']}>
				<Icon
					icon="check_circle"
					tooltip={`Approve this user role action request (${rowData.action})`}
					className={`${styles['actions-icon']} ${styles['table-icon']} approve`}
					onClick={() => handleApproveUserRole(rowData)}
				/>
				<Tooltip target=".approve" position="top" className={styles.tooltip} />
				<Icon
					icon="delete"
					tooltip="Delete this user creation request"
					className={`${styles['actions-icon']} ${styles['table-icon']} delete`}
					onClick={() => handleDeleteUserRole(rowData)}
				/>
				<Tooltip target=".delete" position="top" className={styles.tooltip} />
				<Button
					className={styles['action-button']}
					onClick={() => handleGetUserRoleDetails(rowData)}
				>
					View Details
				</Button>
				<Dialog
					header="User Role Details"
					visible={rowData.visible}
					onHide={() => {
						//Change one single object -> UserRole roleName
						const updatedUserRoleDetails = {
							...userRoleDetails,
							visible: false,
						};
						setUserRoleDetails(updatedUserRoleDetails);
						//Change array of objects to maintain state -> UserRole
						const updatedUserRoleList = userRoles.map((userObj) =>
							userObj.roleName === rowData.roleName
								? updatedUserRoleDetails
								: userObj
						);
						setUserRoles(updatedUserRoleList);
					}}
				>
					<ViewUserData userData={userRoleDetails} isRoleData />
				</Dialog>
			</div>
		);
	};

	const permissionTemplate = (rowData) => {
		return (
			<div>
				<Button
					onClick={() => handleShowPermission(rowData)}
					className={styles['action-button']}
				>
					Click to view
				</Button>
				<Dialog
					header={`Role permissions (${rowData.permissionGroupList?.length})`}
					visible={rowData.visiblePermission}
					onHide={() => {
						//Get user role obj and change visibility
						const newUserRoleList = userRoles.map((obj) => {
							if (obj.roleName === rowData.roleName) {
								const newUserRoleObj = { ...obj, visiblePermission: false };
								return newUserRoleObj;
							}
							return obj;
						});
						// console.log(newUserRoleList);
						//Set new user role list to re-render the rowData
						setUserRoles(newUserRoleList);
					}}
				>
					<div className={styles['permission-group__container']}>
						{rowData.permissionGroupList?.map((permission) => (
							<div key={permission}>{permission}</div>
						))}
					</div>
				</Dialog>
			</div>
		);
	};

	return (
		<div className="main">
			<Heading>Approve User Role Actions</Heading>
			<div className={styles['user__container']}>
				<div className={styles['table__container']}>
					<DataTable
						value={userRoles}
						paginator
						rows={10}
						rowsPerPageOptions={[5, 10, 15, 20, 30, 50]}
						emptyMessage="No pending user roles found."
						removableSort
					>
						{CONSTANTS.userRoleColumns.map((col) => (
							<Column
								key={col.field}
								field={col.field}
								header={col.header}
								sortable
								className={styles['wrap-text']}
							/>
						))}
						<Column
							body={permissionTemplate}
							field="permissionGroupList"
							header="Permissions"
						></Column>
						<Column
							body={creationDateTemplate}
							field="creationDate"
							header="Creation Date"
							sortable
						></Column>
						<Column field="action" header="Action" sortable></Column>
						<Column
							body={actionBodyTemplate}
							field="actions"
							header="User Actions"
							className={styles['actions__container_alt']}
						></Column>
					</DataTable>
				</div>
			</div>
		</div>
	);
};

export default ApproveUserRoles;
